// extracted by mini-css-extract-plugin
module.exports = {"ceoBlock":"CEOBlock_ceoBlock__2TuLB","topInfo":"CEOBlock_topInfo__2hLIu","ceoImage":"CEOBlock_ceoImage__2MEuX","info":"CEOBlock_info__kl1f2","text":"CEOBlock_text__2L_z7"};